__webpack_require__.p = "/interactive/destination-canada/this-is-canada/nova-scotia/";